import Vue from 'vue'
import Vuex from 'vuex'
import {vuex as app} from '../app'
import * as TYPES from './types'
import {isEmpty} from 'lodash'
import baseConfig from '../config'
import {setToken} from '../http'
import {set, clear} from '@utils/storage'

Vue.use(Vuex)

const defaultState = {
  config: {
    apiPath: baseConfig.basePath
  },
  user: {
    id: null,
    pessoa: {
      nome: '',
      avatar: ''
    }
  },
  token: '',
  isLoading: true,
  loadingMessage: 'Carregando Dados',
  showSidebar: true,
  notification: {
    title: '',
    message: ''
  },
  axiosExcludeRoutesErrorMessage: []
}

export default new Vuex.Store({
  state: Object.assign({}, defaultState),
  mutations: {
    [TYPES.LOADER_SHOW] (state, payload) {
      state.isLoading = payload
    },
    [TYPES.LOADER_MESSAGE] (state, payload) {
      state.loadingMessage = payload
    },
    [TYPES.AUTH_USER] (state, payload) {
      state.user = payload
    },
    [TYPES.AUTH_TOKEN] (state, payload) {
      setToken(payload)
      state.token = payload
    },
    [TYPES.TOGGLE_SIDEBAR] (state) {
      state.showSidebar = !state.showSidebar
    },
    [TYPES.NOTIFICATION] (state, payload) {
      state.notification = payload
    },
    [TYPES.AXIOS_EXCLUDE_ROUTES_ERROR] (state, payload) {
      state.axiosExcludeRoutesErrorMessage = [...state.axiosExcludeRoutesErrorMessage, ...payload]
    }
  },
  actions: {
    showLoader: (context, payload) => {
      context.commit(TYPES.LOADER_MESSAGE, payload && payload.message ? payload.message : defaultState.loadingMessage)
      context.commit(TYPES.LOADER_SHOW, true)
    },
    hideLoader: (context) => {
      setTimeout(() => {
        context.commit(TYPES.LOADER_SHOW, false)
      }, 400)
    },
    login: (context, payload) => {
      return new Promise((resolve) => {
        set('user', payload.user)
        set('token', payload.token)
        context.commit(TYPES.AUTH_USER, payload.user)
        context.commit(TYPES.AUTH_TOKEN, payload.token)
        resolve()
      })
    },
    setUser: (context, payload) => {
      return new Promise((resolve) => {
        set('user', payload)
        context.commit(TYPES.AUTH_USER, payload)
        resolve()
      })
    },
    setToken: (context, payload) => {
      return new Promise((resolve) => {
        set('token', payload)
        context.commit(TYPES.AUTH_TOKEN, payload)
        resolve()
      })
    },
    logout: (context) => {
      return new Promise((resolve) => {
        clear()
        context.commit(TYPES.AUTH_USER, Object.assign({}, defaultState.user))
        context.commit(TYPES.AUTH_TOKEN, '')
        resolve()
      })
    },
    toggleSidebar: (context) => {
      context.commit(TYPES.TOGGLE_SIDEBAR)
    },
    showNotification: (context, payload) => {
      context.commit(TYPES.NOTIFICATION, payload)
    },
    axiosExcludeRoutesErrorMessage: (context, payload) => {
      context.commit(TYPES.AXIOS_EXCLUDE_ROUTES_ERROR, payload)
    }
  },
  getters: {
    config: ({config}) => config,
    isLogged: ({token}) => !isEmpty(token),
    token: ({token}) => token,
    currentUser: ({user}) => user,
    isLoading: ({isLoading}) => isLoading,
    loadingMessage: ({loadingMessage}) => loadingMessage,
    showSidebar: ({showSidebar}) => showSidebar,
    notification: ({notification}) => notification,
    axiosExcludeRoutesErrorMessage: ({axiosExcludeRoutesErrorMessage}) => axiosExcludeRoutesErrorMessage
  },
  modules: {
    ...app
  }
})



// WEBPACK FOOTER //
// ./src/vuex/index.js